const incrementalNumberContainer = document.querySelector('.product-input-description');
const dynamicEntryContainer = document.querySelector('#dynamicEntry');

// [✅] Set incrmental number
// [] Get all orders with 100K
// [] Add to current number each x = [incremental_number] orders
if(dynamicEntryContainer){
  let incrementalNumber = parseInt(incrementalNumberContainer?.dataset?.incremental, 10);
  console.log('Container exists');
}